<template>
<div style="float: left; width: 100%;">

    <div class="list-group">
        <div class="list-group-item log-head">
            <div class="row">
                <div class="col-md-8">
                    Gäller från
                </div>
                <div class="col-md-8">
                    Typ
                </div>
                <div class="col-md-28">
                    Kommentar
                </div>
            </div>
        </div>

        <div class="list-group-item log-item" v-for="entry in address.log_active">
            <div class="row">
                <div class="col-md-8">
                    {{ entry.date.substr(0, 10) }}
                </div>
                <div class="col-md-8">
                    {{ typeString(entry.type) }}
                </div>
                <div class="col-md-28">
                    {{ entry.comment }}
                </div>
                <div class="col-md-4">
                    <div class="btn btn-xs btn-info" style="float:right;" v-on:click="edit(entry)">
                        Ändra
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="btn btn-xs btn-danger" style="float:right;" @click="trash(entry)">
                        -
                    </div>
                </div>
            </div>
        </div>

        <div class="list-group-item log-add" :class="{ store: newEntry.id != 'new'}">
            <div class="row">

                <div class="col-md-8">
                    <datepicker
                        :format="dateFormat"
                        v-model="newEntry.date"
                        :disabled="disabledDates"
                        language="sv"
                        input-class="form-control"
                        :monday-first="true">
                    </datepicker>
                </div>

                <div class="col-md-8">
                    <span v-if="newEntry.id == 'new'">
                        {{ typeString(newEntryType) }}
                    </span>
                    <span v-else>
                        {{ typeString(newEntry.type) }}
                    </span>
                </div>

                <div class="col-md-28">
                    <textarea class="form-control" style="height: 80px;" v-model="newEntry.comment"></textarea>
                </div>

                <div class="col-md-6">
                    <div class="btn btn-default" style="float:right;" @click="save()" v-if="newEntry.id == 'new'">
                        Lägg till
                    </div>
                    <div class="btn btn-xs btn-default" style="float:right; margin-left:10px;" @click="save()" v-if="newEntry.id != 'new'">
                        Spara
                    </div>
                    <div class="btn btn-xs btn-info" style="float:right;" @click="reset()" v-if="newEntry.id != 'new'">
                        Avbryt
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
</template>

<script>

    export default {

        props: {

            address: {
                required: true,
            }

        },

        data ()
        {
            return {
                newEntry: {
                    id      : 'new',
                    date    : new Date(),
                    type    : '',
                    comment : '',
                },

                dateFormat: 'yyyy-MM-dd',
                submited: false,
            }
        },

        computed: {

            hasNoEntries ()
            {
                return this.address.log_active.length === 0
            },

            lastEntry ()
            {
                return this.address.log_active[this.address.log_active.length - 1]
            },

            newEntryType ()
            {
                if (this.hasNoEntries || this.lastEntry.type != 'active') {
                    return 'active'
                } else {
                    return 'inactive'
                }
            },

            disabledDates ()
            {
                if (this.hasNoEntries) {
                    return  {}
                }

                if (this.newEntry.id == 'new') {
                    return {
                        to: moment(this.lastEntry.date).endOf("day").toDate()
                    }
                }

                let to = null
                let from = null

                const currentEntryIndex = _.findIndex(this.address.log_active, ['id', this.newEntry.id])
                if (currentEntryIndex > 0) {
                    to = moment(this.address.log_active[currentEntryIndex - 1].date).endOf("day").toDate()
                }
                if (currentEntryIndex < (this.address.log_active.length -1)) {
                    from = moment(this.address.log_active[currentEntryIndex + 1].date).startOf("day").toDate()
                }

                return {
                    to: to,
                    from: from
                }
            }

        },

        created ()
        {
            this.reset()
        },

        methods: {

            edit (entry)
            {
                this.newEntry.id      = entry.id
                this.newEntry.date    = moment(entry.date).toDate()
                this.newEntry.type    = entry.type
                this.newEntry.comment = entry.comment
            },

            save ()
            {
                if (this.submited) {
                    return
                }

                this.submited = true

                this.$http.post(
                    '/addresses/'+this.address.id+'/saveLogActive',
                    {
                        id      :    this.newEntry.id,
                        date    :    this.newEntry.date,
                        comment :    this.newEntry.comment,
                        type    :    this.newEntryType
                    }
                )
                .then((response) => {
                    console.log('save addresses log response')
                    console.log(response)

                    this.address.log_active = response.data.log_active
                    this.submited = false

                    if (this.newEntry.id == 'new') {
                        bus.$emit('notify', 'Inlägget sparades.')
                    } else {
                        bus.$emit('notify', 'Inlägget uppdaterades.')
                    }

                    this.reset()

                }, (response) => {
                    console.log(JSON.stringify(response));

                    this.submited = false
                });
            },

            trash (entry)
            {
                if (!confirm('Är du säker?')) {
                    return;
                }

                this.$http.post(
                    '/addresses/'+this.address.id+'/deleteLogActive',
                    {
                        log_id:  entry.id,
                    }
                )
                .then((response) => {
                    console.log('delete addresses log response')
                    console.log(response)

                    this.address.log_active = response.data.log_active

                    bus.$emit('notify', 'Inlägget raderades.')
                }, (response) => {
                    console.log(JSON.stringify(response))
                });
            },

            reset ()
            {
                this.newEntry.id = 'new'

                if (this.hasNoEntries) {
                    this.newEntry.date = new Date()
                } else {
                    this.newEntry.date = moment(this.lastEntry.date).add(1, 'days').toDate()
                }

                this.newEntry.type = ''
                this.newEntry.comment = ''
            },

            typeString (type)
            {
                return type == 'active' ? 'Uppe i portal' : 'Ej uppe i portal'
            },

        }

    }

</script>
